import { POST_SALES_LISTING, SITE_INSPECTION_LISTING, INSPECTION_CREATED } from "./type";

const initalState = {
  postSalesList: {},
  siteInspectionList: {},
  inspectionCreatedData: {},
};

const postSalesListReducer = (state = initalState, action) => {
  const { type, payload } = action;
  switch (type) {
    case POST_SALES_LISTING:
      return {
        ...state,
        postSalesList: payload,
      };
    case SITE_INSPECTION_LISTING:
      return {
        ...state,
        siteInspectionList: payload,
      };
      case INSPECTION_CREATED:
        return {
          ...state,
          inspectionCreatedData: payload,
        };
    default:
      return {
        ...state,
      };
  }
};

export default postSalesListReducer;
